import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider, message, notification } from "antd";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

message.config({
  duration: 3,
  maxCount: 3,
  top: 24,
});

notification.config({
  duration: 3,
  maxCount: 3,
  placement: "topRight",
});

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0f766e",
          colorInfo: "#0f766e",
          colorLink: "#0f766e",
          colorSuccess: "#15803d",
          borderRadius: 8,
        },
        components: {
          Button: {
            colorPrimary: "#0f766e",
            colorPrimaryHover: "#115e59",
            colorPrimaryActive: "#134e4a",
          },
          Menu: {
            itemSelectedBg: "#e6f4f1",
            itemSelectedColor: "#0f766e",
          },
        },
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
